import IntegrationHelperRepository from "@/repositories/vns/IntegrationHelperRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'integrationHelper',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await IntegrationHelperRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.helper)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await IntegrationHelperRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.helpers.data)
            })
            commit('setLoading', false)
        }
    }
}
